import { useCallback, useMemo, useState } from 'react'

import { useSessionLanguage } from '../../../../global/context/SessionSettingsContext'
import { FilterQueryProps } from '../../../../global/filter/FilterQueryModal'
import { NameDto } from '../../../../model/NameDto'
import { TradingAccountRebateDetailedDto } from '../../../../model/TradingAccountRebateDetailedDto'
import { useAccountReadContext } from '../../../../utils/AccountContextContext'
import { PageQuery, useApiClient } from '../../../../utils/ApiClient'
import { ClientApiClient } from '../../../../utils/clientApi'
import { IAppendableFetchResult, useFetchAppendablePage } from '../../../../utils/useFetch'

interface IBTradingAccountsRebateSearch {
  tradingAccountOptions: NameDto<string>[]
  query: IAppendableFetchResult<TradingAccountRebateDetailedDto[]>
  search?: FilterQueryProps
  setSearch: (search: FilterQueryProps) => void
  clearSearch: (callback: () => void) => void
}

export const useIBTradingAccountsRebateSearch = (): IBTradingAccountsRebateSearch => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()
  const { account } = useAccountReadContext()

  const [search, setSearch] = useState<FilterQueryProps>()

  const accountSummaryCallback = useCallback(
    async (query?: PageQuery) => {
      return await apiClient.getIBTradingAccountsRebate(
        account?.clientIntroducingBroker?.id ?? '',
        {
          ...query,
          pageIndex: 0,
          pageSize: 25,
          search: search,
          caller: 'ca',
          languageId: locale,
        }
      )
    },
    [search, locale]
  )
  const query = useFetchAppendablePage(accountSummaryCallback, {
    skipLoadingFlag: true,
  })

  const tradingAccountOptions = useMemo(() => {
    return query.data?.map((item) => item.tradingAccount) || []
  }, [query.data])

  const clearSearch = (callback: () => void) => {
    callback()
    setSearch({})
  }

  return {
    tradingAccountOptions,
    query,
    search,
    setSearch,
    clearSearch,
  }
}
